import React, { useState, useEffect } from 'react';
import { UpArrowAlt } from 'styled-icons/boxicons-regular';

const GoToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down by 300px
  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div className="fixed bottom-4 right-4">
      {isVisible && (
        <button
          onClick={scrollToTop}
          className={`p-3 rounded-full bg-[#5a3d86] text-white shadow-md hover:bg-[#3a2c59]`}
        >
          <UpArrowAlt size={24} />
        </button>
      )}
    </div>
  );
};

export default GoToTopButton;
